import React from "react";

const NoItem = () => {
  return (
    <div className="my-24 flex items-center justify-center">
      <h1 className="text-center font-semibold">
        There is no items to be check out Please delete add yours
      </h1>
    </div>
  );
};

export default NoItem;
